export const NotFound = () => {
    return (
        <div>
            Page Not Found
        </div>
    );
}